import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import PreOrderMeals from '../Components/PreOrderMeals/PreOrderMeals'; // renamed import
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   

function PreOrderMealsPage() { // renamed component
    return (
        <>

        <Helmet>
                <title>Pre-Order Homemade Veg Meals in Coimbatore | Tickling Tummy</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, offering customized pre-order tiffin services in R.S. Puram for those who love home-cooked meals. Customized, low-oil, and healthy options available." />
                <meta name="keywords" content="Pre-order veg meals Coimbatore, Homemade vegetarian food, Freshly cooked meals Coimbatore, Pure veg lunch Coimbatore, Dinner pre-order service" />
                <link rel="canonical" href="https://ticklingtummy.com/pre-order-meals" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Pre-Order Homemade Veg Meals in Coimbatore | Tickling Tummy" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, offering customized pre-order tiffin services in R.S. Puram for those who love home-cooked meals. Customized, low-oil, and healthy options available." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/custom-pre-order-meals-coimbatore.jpg" />
                <meta property="og:url" content="https://ticklingtummy.com/pre-order-meals" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Pre-Order Homemade Veg Meals in Coimbatore | Tickling Tummy" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, offering customized pre-order tiffin services in R.S. Puram for those who love home-cooked meals. Customized, low-oil, and healthy options available." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/custom-pre-order-meals-coimbatore.jpg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
  {
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://ticklingtummy.com"
  },
  {
    "@type": "ListItem",
    "position": 2,
    "name": "Pre-order Meals",
    "item": "https://ticklingtummy.com/pre-order-meals"
  }
]
        }, null, 2)}
        </script>
            <HeaderOne />
            <PreOrderMeals />
            <Footer />
        </>
    );
}

export default PreOrderMealsPage;
